function authorize(mjpgUrl: string): void {
  window.fetch(mjpgUrl, {
    credentials: 'include',
    mode: 'no-cors',
  });
}

export default authorize;
